import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { DividerStyleEnum, Alignment } from '@teko-builder/types/shared';
import { CommonStyles } from './components/shared/BaseProps.es.js';
import { unitParse } from './utils.es.js';
import styled from '@emotion/styled';

const Divider = (_a) => {
    var { width = '100%', height = '1px', color = 'black', dividerStyle = DividerStyleEnum.solid, align, gap, alignContent, spacingContent, children } = _a, rest = __rest(_a, ["width", "height", "color", "dividerStyle", "align", "gap", "alignContent", "spacingContent", "children"]);
    const renderSeparator = () => {
        if (!children) {
            return (jsx(WrapperSeparator, { width: width, weight: height, dividerStyle: dividerStyle, color: color, align: align }));
        }
        return (jsx(WrapperSeparatorText, Object.assign({ width: width, weight: height, dividerStyle: dividerStyle, color: color, align: align, alignContent: alignContent, spacingContent: spacingContent }, { children: jsx("span", { children: children }) })));
    };
    return (jsx(WrapperDivider, Object.assign({}, rest, { gap: gap }, { children: renderSeparator() })));
};
const WrapperDivider = styled.div(({ gap }) => [
    CommonStyles,
    `
  --divider-gap: ${unitParse(gap) || '12px'};
  display: flex;
  padding-top: var(--divider-gap);
  padding-bottom: var(--divider-gap);
`,
]);
const transformAlign = (align) => {
    switch (align) {
        case Alignment.center:
            return 'margin: 0 auto;';
        case Alignment.right:
            return `
        margin: 0 auto;
        margin-right: 0;
      `;
        default:
            return '';
    }
};
const transformAlignContent = (alignContent) => {
    const css = `{
    display: block;
    content: "";
    border-bottom: 0;
    flex-grow: 1;
    border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color);
  }`;
    switch (alignContent) {
        case Alignment.left:
            return `
          &:after ${css}
        `;
        case Alignment.right:
            return `
          &:before ${css}
        `;
        default:
            return `
          &:after, &:before ${css}
        `;
    }
};
const WrapperSeparator = styled.div(({ width, weight, dividerStyle, color, align }) => `
  --divider-border-style: ${dividerStyle};
  --divider-color: ${color || '#000000'};
  --divider-border-width: ${weight || '1px'};
  display: flex;
  width: ${width ? width : '100%'};
  border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color);
  ${transformAlign(align)}
`);
const WrapperSeparatorText = styled.div(({ width, weight, dividerStyle, color = 'black', align, alignContent, spacingContent, theme, }) => `
  --divider-border-style: ${dividerStyle};
  --divider-color: ${theme.colors[color] || color};
  --divider-border-width: ${weight || '1px'};
  --divider-content-spacing: ${spacingContent || '10px'};
  display: flex;
  align-items: center;
  width: ${width ? width : '100%'};
  ${transformAlign(align)}
  ${transformAlignContent(alignContent)}

  > span {
    margin: 0 var(--divider-content-spacing);
    margin-left: ${alignContent === 'left' ? '0' : 'var(--divider-content-spacing)'};
    margin-right: ${alignContent === 'right' ? '0' : 'var(--divider-content-spacing)'};
  }
`);
Divider.displayName = 'Divider';

export { Divider as D };
